import { Injectable, ɵDEFAULT_LOCALE_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../_environments/environment';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, EMPTY, Observable, of, throwError } from 'rxjs';
import { Countrycode, Sourcetype, UrlParameters } from '../_model/shared';
import { Shippingmethod } from '../_model/order';
import { AvailableDelivery } from '../_model/weeks';
import { Deliveryday, PostalCodeWeekDayTimeFrame, WeekFromTo } from '../_model/postalcodedelivery';
import { GlobalService } from './GlobalService';
import { formatDate } from '@angular/common';
import { Originentitytype } from 'src/_model/subscription';

@Injectable({ providedIn: 'root' })
export class DeliverydayService {

  private timeframes: PostalCodeWeekDayTimeFrame[] = [];
  private cutoffs: any[] = [];

  availableFirstDeliveryRecipeweeks$ = new BehaviorSubject<WeekFromTo[]>([]);
  constructor(
    private _http: HttpClient,
    private _globalService: GlobalService
  ) {

  }

  getOnetimeboxDelivery(boxid: number, shippingmethod: Shippingmethod, postalcodeNumbers: number, countrycode: Countrycode, voedselbankTimeframes = false): Observable<AvailableDelivery[]> {
    const params = new UrlParameters();
    this._globalService.setPricecountry(Sourcetype.BROWSER, countrycode);
    if (boxid)
      params.addParameter('boxid', boxid.toString());
    if (shippingmethod)
      params.addParameter('shippingmethod', shippingmethod.toString());
    if (postalcodeNumbers)
      params.addParameter('postalcodeNumbers', postalcodeNumbers.toString());
    params.addParameter('countryCode', countrycode?.toString());

    if (params.urlParameters.length !== 4) {
      return EMPTY;
    }
    return this._http.get<AvailableDelivery[]>(environment.apiserver + 'deliveryday/v1/deliveryday/onetimebox' + params.toString()).pipe(
      map((response: AvailableDelivery[]) => {

        response = this.filterVoedselbankTimeframes(response, voedselbankTimeframes) as AvailableDelivery[]
        response.forEach(d => {
          if (!d.originaldate) {
            d.originaldate = d.date;
          }
        });

        return response;
      })
      , catchError(this.handleError)
    );
  }
  getFirstdelivery(shippingmethod: Shippingmethod, postalcodeNumbers: number | string, countrycode: Countrycode, voedselbankTimeframes = false): Observable<Deliveryday[]> {
    const params = new UrlParameters();

    if (!shippingmethod || !postalcodeNumbers || postalcodeNumbers.toString().length < 4 || !countrycode)
      return EMPTY

    this._globalService.setPricecountry(Sourcetype.BROWSER, countrycode);
    if (shippingmethod)
      params.addParameter('shippingmethod', shippingmethod.toString());
    if (postalcodeNumbers)
      params.addParameter('postalcodeNumbers', postalcodeNumbers.toString());
    params.addParameter('countryCode', countrycode?.toString());

    if (params.urlParameters.length !== 3) {
      return EMPTY;
    }
    return this._http.get<Deliveryday[]>(environment.apiserver + 'deliveryday/v1/deliveryday/firstdelivery' + params.toString()).pipe(
      map((response: Deliveryday[]) => {
        response = this.filterVoedselbankTimeframes(response, voedselbankTimeframes) as Deliveryday[]
        response.forEach(d => {
          if (!d.originaldate) 
            d.originaldate = d.date;
        });
        //gets unique weeks
        const availableFirstDeliveryRecipeweeks: WeekFromTo[] = [...new Set(response.map(m=> JSON.stringify(this.getRecipeweekFromTo(m.originaldate))))].map(m=> JSON.parse(m))
        //adds deliverydays to week
        availableFirstDeliveryRecipeweeks.map(m=> 
          m.deliverydays = response.filter(r=> {
            const week = this.getRecipeweekFromTo(r.originaldate)
            return week.from == m.from && week.to == m.to
        }))

        this.availableFirstDeliveryRecipeweeks$.next(availableFirstDeliveryRecipeweeks)
        return <any>response;
      })
      , catchError(this.handleError)
    );
  }

  getRecipeSubscriptionDeliverydates(subscriptionid: number): Observable<Deliveryday[]> {
    return this._http.get<Deliveryday[]>(environment.apiserver + 'deliveryday/v1/deliveryday/recipesubscription/' + subscriptionid + '/list').pipe(
      map((response: Deliveryday[]) => {
        return response.map(m => {
          m._originentitytype = Originentitytype.RECIPE_SUBSCRIPTION;
          m._subscriptionid = subscriptionid
          return m;
        })
      })
      , catchError(this.handleError)
    );
  }
  getBoxSubscriptionDeliverydates(subscriptionid: number): Observable<Deliveryday[]> {
    return this._http.get<Deliveryday[]>(environment.apiserver + 'deliveryday/v1/deliveryday/boxsubscription/' + subscriptionid + '/list').pipe(
      map((response: Deliveryday[]) => {
        return response.map(m => {
          m._originentitytype = Originentitytype.BOX_SUBSCRIPTION;
          m._subscriptionid = subscriptionid
          return m;
        })
      })
      , catchError(this.handleError)
    );
  }

  getRecipeSubscriptionAlterativeDeliverydates(subscriptionid: number, shippingmethod: Shippingmethod, postalcode: string, countrycode: Countrycode, voedselbankTimeframes = false): Observable<Deliveryday[]> {

    if (!postalcode) { return of(null) }

    const params = new UrlParameters();
    postalcode = postalcode.replace(/[^0-9]+/g, "")
    if (postalcode.length < 4) { return of(null) };

    this._globalService.setPricecountry(Sourcetype.BROWSER, countrycode);

    params.addParameter("shippingmethod", shippingmethod);
    params.addParameter("postalcodeNumbers", postalcode.toString());
    params.addParameter("countryCode", countrycode);

    if (params.length !== 3) { return of(null) }

    return this._http.get<AvailableDelivery[]>(environment.apiserver + 'deliveryday/v1/deliveryday/recipesubscription/' + subscriptionid + '/alternatives' + params.toString()).pipe(
      map((response: AvailableDelivery[]) => {

        response = this.filterVoedselbankTimeframes(response, voedselbankTimeframes) as AvailableDelivery[]

        const weekdays = this._globalService.getWeekdays()
        response = response.sort((a, b) => {
          if (!a.postalCodeWeekDayTimeFrames[0] || !b.postalCodeWeekDayTimeFrames[0]) { return 0 }
          if (weekdays.indexOf(a.postalCodeWeekDayTimeFrames[0].weekday) < weekdays.indexOf(b.postalCodeWeekDayTimeFrames[0].weekday)) return -1
          if (weekdays.indexOf(a.postalCodeWeekDayTimeFrames[0].weekday) > weekdays.indexOf(b.postalCodeWeekDayTimeFrames[0].weekday)) return 1
          return 0
        })
        return response
      })
      , catchError(this.handleError)
    );
  }

  getBoxSubscriptionAlterativeDeliverydates(subscriptionid: number, shippingmethod: Shippingmethod, postalcode: string, countrycode: Countrycode, voedselbankTimeframes = false): Observable<AvailableDelivery[]> {

    if (!postalcode) { return of(null) }
    const params = new UrlParameters();
    postalcode = postalcode.replace(/[^0-9]+/g, "")
    if (!postalcode || postalcode.length < 4) { return of(null) };

    this._globalService.setPricecountry(Sourcetype.BROWSER, countrycode);

    params.addParameter("shippingmethod", shippingmethod);
    params.addParameter("postalcodeNumbers", postalcode.toString());
    params.addParameter("countryCode", countrycode);

    return this._http.get<AvailableDelivery[]>(environment.apiserver + 'deliveryday/v1/deliveryday/boxsubscription/' + subscriptionid + '/alternatives' + params.toString()).pipe(
      map((response: AvailableDelivery[]) => {

        response = this.filterVoedselbankTimeframes(response, voedselbankTimeframes) as AvailableDelivery[]

        const weekdays = this._globalService.getWeekdays()
        response = response.sort((a, b) => {
          if (weekdays.indexOf(a.postalCodeWeekDayTimeFrames[0].weekday) < weekdays.indexOf(b.postalCodeWeekDayTimeFrames[0].weekday)) return -1
          if (weekdays.indexOf(a.postalCodeWeekDayTimeFrames[0].weekday) > weekdays.indexOf(b.postalCodeWeekDayTimeFrames[0].weekday)) return 1
          return 0
        })
        return response
      })
      , catchError(this.handleError)
    );
  }

  getTimeframe(id: number): Observable<PostalCodeWeekDayTimeFrame> {
    const timeframe = this.timeframes.filter(f => f.id == id)[0];
    if (timeframe)
      return of(timeframe)

    return this._http.get<PostalCodeWeekDayTimeFrame>(environment.apiserver + 'postalcodedelivery/v1/postalcodedelivery/postalcoderange/postalcodeweekdaytimeframe/' + id).pipe(
      map((response: PostalCodeWeekDayTimeFrame) => {
        this.timeframes.push(response)
        return response
      })
      , catchError(this.handleError)
    );
  }
  getCutoffs(deliverydates: any[], shippingmethod: Shippingmethod): Observable<[{ date: any, cutoff: any }]> {
    //  const timeframe = this.timeframes.filter(f => f.id == id)[0];
    //     if (timeframe)
    //       return of(timeframe)

    const params = new UrlParameters();
    params.addParameter("deliverydates", deliverydates.join(","))
    params.addParameter("shippingmethod", shippingmethod)

    return this._http.get<[{ date: any, cutoff: any }]>(environment.apiserver + 'deliveryday/v1/deliveryday/cutoffs' + params.toString()).pipe(
      map((response: [{ date: any, cutoff: any }]) => {
        return response
      })
      , catchError(this.handleError)
    );
  }

  getDeliveryAlternativeDeliverydates(deliverydate: string, shippingmethod: Shippingmethod, postalcode: string, countrycode: Countrycode, voedselbankTimeframes = false): Observable<AvailableDelivery[]> {
    if (!postalcode) { return of(null) }
    const params = new UrlParameters();
    postalcode = postalcode.replace(/[^0-9]+/g, "")
    if (!postalcode || postalcode.length < 4) { return of(null) };

    let fromdate = this.getFirstdayOfRecipeWeek(deliverydate);
    let todate = this.getLastdayOfRecipeWeek(deliverydate);

    this._globalService.setPricecountry(Sourcetype.BROWSER, countrycode);

    params.addParameter("shippingmethod", shippingmethod);
    params.addParameter("postalcodeNumbers", postalcode.toString());
    params.addParameter("countryCode", countrycode);
    params.addParameter("from", formatDate(fromdate, "yyyy-MM-dd", ɵDEFAULT_LOCALE_ID));
    params.addParameter("to", formatDate(todate, "yyyy-MM-dd", ɵDEFAULT_LOCALE_ID));
    params.addParameter("countryCode", countrycode);

    return this._http.get<AvailableDelivery[]>(environment.apiserver + 'deliveryday/v1/deliveryday/alternativesfordelivery' + params.toString()).pipe(
      map((response: AvailableDelivery[]) => {

        response = this.filterVoedselbankTimeframes(response, voedselbankTimeframes) as AvailableDelivery[]

        const weekdays = this._globalService.getWeekdays()
        response = response.sort((a, b) => {
          if (weekdays.indexOf(a.postalCodeWeekDayTimeFrames[0].weekday) < weekdays.indexOf(b.postalCodeWeekDayTimeFrames[0].weekday)) return -1
          if (weekdays.indexOf(a.postalCodeWeekDayTimeFrames[0].weekday) > weekdays.indexOf(b.postalCodeWeekDayTimeFrames[0].weekday)) return 1
          return 0
        })
        return response
      })
      , catchError(this.handleError)
    );
  }

  private filterVoedselbankTimeframes(deliverydays: Deliveryday[] | AvailableDelivery[], voedselbankTimeframes: boolean): Deliveryday[] | AvailableDelivery[] {

    // console.log(deliverydays.flatMap(m => m.postalCodeWeekDayTimeFrames.map(m => m.id)).length, deliverydays.flatMap(m => m.postalCodeWeekDayTimeFrames.map(m => m)))
    //returns no voedselbank timeframes
    if (!voedselbankTimeframes)
      deliverydays.map(d => d.postalCodeWeekDayTimeFrames = d.postalCodeWeekDayTimeFrames.filter(f => !environment.voedselbank_timeframe_ids.includes(f.id)))

    //returns only voedselbank timeframes
    if (voedselbankTimeframes)
      deliverydays.map(d => d.postalCodeWeekDayTimeFrames = d.postalCodeWeekDayTimeFrames.filter(f => environment.voedselbank_timeframe_ids.includes(f.id)))

    // console.log(deliverydays.flatMap(m => m.postalCodeWeekDayTimeFrames.map(m => m.id)).length, deliverydays.flatMap(m => m.postalCodeWeekDayTimeFrames.map(m => m)))
    return deliverydays.filter(d => d.postalCodeWeekDayTimeFrames.length > 0)
  }

  getFirstdayOfRecipeWeek(date: any): Date {
    let sd = new Date(date);
    let startoffset = DeliverydayService.getWeekStartOffset(sd);
    let startdate = new Date(sd.setDate(sd.getDate() + startoffset));

    return startdate;
  }
  getLastdayOfRecipeWeek(date: any): Date {
    let ed = new Date(date);
    let endoffset = DeliverydayService.getWeekEndOffset(ed);
    let enddate = new Date(ed.setDate(ed.getDate() + endoffset));

    return enddate;
  }

  getRecipeweekFromTo(date: any): { from: any, to: any } {
    return {
      from: formatDate(this.getFirstdayOfRecipeWeek(date), "yyyy-MM-dd", ɵDEFAULT_LOCALE_ID),
      to: formatDate(this.getLastdayOfRecipeWeek(date), "yyyy-MM-dd", ɵDEFAULT_LOCALE_ID),
    }
  }

  static getIsoWeekday(date: Date): number {
    return date.getDay() == 0 ? 6 : date.getDay() - 1;
  }

  static getWeekStartOffset(date: Date): number {
    const isoWeekday = DeliverydayService.getIsoWeekday(date);
    return isoWeekday >= 3 ? (isoWeekday - 3) * -1 : (isoWeekday + 4) * -1;
  }

  static getWeekEndOffset(date: Date): number {
    const isoWeekday = DeliverydayService.getIsoWeekday(date);
    return isoWeekday <= 2 ? 2 - isoWeekday : 9 - isoWeekday;
  }

  private handleError(error: Response) {
    if (error.status === 400) {
      return throwError(() => 'Bad request');
    }
    return throwError(() => error || 'Server error');

  }

}
